import React from 'react';
import SearchResultContain from '../../Componant/SearchResult';

const SearchResult = () => {
  return (
    <div className='page-body'>
      <SearchResultContain />
    </div>
  );
};

export default SearchResult;
